import api from './api';

const getUniversities = async () => {
    const response = await api.get('/university');
    return response.data;
};

const getUniversityById = async (id) => {
    const response = await api.get(`/university/${id}`);
    return response.data;
};

const createUniversity = async (universityData) => {
    const response = await api.post('/university', universityData);
    return response.data;
};

const updateUniversity = async (id, universityData) => {
    const response = await api.put(`/university/${id}`, universityData);
    return response.data;
};

const deleteUniversity = async (id) => {
    const response = await api.delete(`/university/${id}`);
    return response.data;
};

const universityService = {
    getUniversities,
    getUniversityById,
    createUniversity,
    updateUniversity,
    deleteUniversity
};

export default universityService;